import { render } from "./CategoryPointsTable.vue?vue&type=template&id=18cb2f3c"
import script from "./CategoryPointsTable.vue?vue&type=script&lang=js"
export * from "./CategoryPointsTable.vue?vue&type=script&lang=js"

import "./CategoryPointsTable.vue?vue&type=style&index=0&id=18cb2f3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__